import { ActionButtonContainer } from "@components/action-buttons/action-button-container";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { SphereTooltip } from "@components/common/sphere-tooltip";
import { ShareProjectButton } from "@components/project/share-project-button";
import { BaseProjectProps } from "@custom-types/project-types";
import { ArchiveIcon, UnarchiveIcon, DeleteIcon, DownloadIcon } from "@flat-ui";
import { useProjectActions } from "@hooks/projects/use-project-actions";
import { DeleteProject } from "@pages/project-details/project-overview/delete-project";
import { useState } from "react";

/**
 * List of all the buttons that will be shown on project overview tab
 */
export function ProjectOverviewActionButtons({
  project,
}: BaseProjectProps): JSX.Element {
  const [shouldShowDialog, setShouldShowDialog] = useState<boolean>(false);
  const {
    archiveOrUnarchiveProject,
    isProjectActive,
    isAllowedToArchiveOrUnarchive,
    isArchiveActionDisabled,
    canDeleteProject,
    canDownloadFromVault,
    openInSphereVault,
  } = useProjectActions(project);

  return (
    <>
      {/* Button to Archive / Unarchive project */}
      {isAllowedToArchiveOrUnarchive && (
        <ActionButtonContainer>
          <SphereTooltip
            title={`${isProjectActive ? "Archive" : "Unarchive"} project`}
          >
            <SphereIconButton
              isDisabled={isArchiveActionDisabled}
              component={isProjectActive ? ArchiveIcon : UnarchiveIcon}
              onClick={() => archiveOrUnarchiveProject()}
            />
          </SphereTooltip>
        </ActionButtonContainer>
      )}

      {/* Button to download the project via Sphere Vault (beta) */}
      {canDownloadFromVault && (
        <ActionButtonContainer>
          <SphereTooltip title="Download from Sphere Vault">
            <SphereIconButton
              component={DownloadIcon}
              onClick={openInSphereVault}
            />
          </SphereTooltip>
        </ActionButtonContainer>
      )}

      {/* Button to share a link to the project */}
      <ActionButtonContainer>
        <ShareProjectButton
          project={project}
          location="project-overview-page"
        />
      </ActionButtonContainer>

      {/* Button to delete a project */}
      {!isProjectActive && canDeleteProject && (
        <ActionButtonContainer>
          <SphereTooltip title="Delete Project">
            <SphereIconButton
              component={DeleteIcon}
              onClick={() => setShouldShowDialog(true)}
            />
          </SphereTooltip>
        </ActionButtonContainer>
      )}

      {/* Render DeleteProject dialog */}
      {shouldShowDialog && (
        <DeleteProject
          project={project}
          onClose={() => setShouldShowDialog(false)}
        />
      )}
    </>
  );
}
